import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// браузерные расширения (Google Translate и др.) перемещают DOM-ноды
// внутри компонентов. При размонтировании React вызывает removeChild на ноде,
// которой уже нет у этого родителя - приложение падает с NotFoundError.
// Патч перехватывает такие вызовы и молча пропускает их вместо броска исключения.
// В нормальной работе React условие child.parentNode !== this никогда не срабатывает.
// https://github.com/facebook/react/issues/11538
// https://amocrm.atlassian.net/browse/AUTO-4559
const originalRemoveChild = Node.prototype.removeChild;
// eslint-disable-next-line func-names
Node.prototype.removeChild = function (child) {
  if (child.parentNode !== this) {
    return child;
  }
  return originalRemoveChild.call(this, child);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
